// extracted by mini-css-extract-plugin
export default {"tooltip":"_R-z","arrow":"aS-z"};